"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyRoute = exports.renderLazyRoute = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Loader_1 = require("@reactionable/core/lib/ui/loader/Loader");
const react_router_dom_1 = require("react-router-dom");
function renderLazyRoute({ component, render, }) {
    const LazyRouteComponent = (props) => {
        let rendered;
        if (component) {
            const Component = Loader_1.lazyLoad(component);
            rendered = jsx_runtime_1.jsx(Component, Object.assign({}, props), void 0);
        }
        else if (render) {
            rendered = render(props);
        }
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: rendered }, void 0);
    };
    return LazyRouteComponent;
}
exports.renderLazyRoute = renderLazyRoute;
function LazyRoute(_a) {
    var { component, render } = _a, routeProps = tslib_1.__rest(_a, ["component", "render"]);
    return (jsx_runtime_1.jsx(react_router_dom_1.Route, Object.assign({ render: renderLazyRoute({
            component,
            render,
        }) }, routeProps), void 0));
}
exports.LazyRoute = LazyRoute;
//# sourceMappingURL=LazyRoute.js.map